module.exports = __webpack_public_path__ + "static/table-bg-24c9c7a9cefa06690412248961a7232e.jpg";